import React, { Fragment } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { GatsbyImage } from 'gatsby-plugin-image';
import {
  COLOR_DARK_GREEN,
  OVERLAY_GRAY,
  MAIN_HEADING_FONT,
  COLOR_GREEN,
  COLOR_BORDER_GRAY,
  screen,
} from '../common/variables';
import staticImages from '../../images/';

const DesktopGalleryWrapper = styled.div`
  display: none;
  position: relative;
  @media ${screen.largeXL} {
    display: block;
  }

  .next-btn {
    cursor: pointer;
    width: 37px;
    position: absolute;
    z-index: 1;
    top: 40%;
    transform: translateY(-50%);
    right: 18px;
  }

  .prev-btn {
    cursor: pointer;

    width: 37px;
    position: absolute;
    z-index: 1;
    top: 40%;
    transform: translateY(-50%);
    left: 18px;
  }
`;

const BigImage = styled.div`
  position: relative;
  z-index: 0;

  .video-container {
    iframe {
      width: 100%;
      z-index: 0;
      height: 360px;
    }
  }
`;

const GalleryCaption = styled.div`
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 18px;
  box-sizing: border-box;
  background-color: #ebebeb;
  @media ${screen.largeXL} {
    bottom: 0;
    color: #3a3a3a;
    background-color: ${OVERLAY_GRAY};
  }
  .heading {
    ${MAIN_HEADING_FONT}
    margin-bottom: 0;
    font-weight: 400;
    line-height: 1.2;
  }
  .product-code {
    font-weight: 300;
    ${COLOR_GREEN}
    p {
      margin-top: 0;
      font-size: 15px;
      line-height: 1.2;
    }
  }
`;
const ThumbnailsWrapper = styled.div`
  padding: 0 1.5rem;
  display: flex;
  flex-direction: row;
  position: relative;

  .gallery__thumbnails {
    display: flex;
    flex: 1 1 100%;
    flex-direction: row;
    padding: 10px 0;
    justify-content: space-between;
    align-items: center;
  }
  .thumbnail {
    cursor: pointer;

    line-height: 0;
    padding: 0;
    border: 1px solid ${COLOR_BORDER_GRAY};
    box-sizing: content-box;
    margin: 1px 6px;
    &.active {
      border-color: ${COLOR_DARK_GREEN};
      border-width: 2px;
      margin: 0 5px;
    }
  }
  .gatsby-image-wrapper {
    /* Let event listener listen to the correct event */
    pointer-events: none;
  }
  .gallery__button {
    cursor: pointer;
    position: absolute;
    box-sizing: content-box;
    height: 20px;
    width: 20px;
    top: 50px;
    background-color: white;
    border: 1px solid ${COLOR_BORDER_GRAY};
    padding: 0;
    color: ${COLOR_BORDER_GRAY};
    &-prev {
      left: 0;
    }
    &-next {
      right: 0;
    }
    display: flex;
    justify-content: center;
    img {
      display: block;
      pointer-events: none;
      height: 14px;
      margin: 3px 0 0 0;
    }
  }
`;

const ThumbnailsWrapperMobile = styled.div`
  padding: 0 1.5rem;
  display: flex;
  flex-direction: row;
  position: relative;
  .gallery__thumbnails {
    display: flex;
    flex: 1 1 100%;
    flex-direction: row;
    padding: 10px 0;
    justify-content: space-between;
    align-items: center;
  }
  .thumbnail {
    cursor: pointer;
    margin: 0 5px;
    line-height: 0;
    padding: 0;
    border: 1px solid ${COLOR_BORDER_GRAY};
    box-sizing: content-box;
    &.active {
      border-color: ${COLOR_DARK_GREEN};
      border-width: 2px;
    }
  }
  .gatsby-image-wrapper {
    /* Let event listener listen to the correct event */
    pointer-events: none;
  }
`;

const MobileGalleryWrapper = styled.div`
  display: block;
  @media ${screen.medium} {
    width: 90vw;
    max-width: 600px;
    margin-top: 30px;
  }

  .gallery__button {
    cursor: pointer;
    position: absolute;
    box-sizing: content-box;
    background-color: white;
    border: 2px solid ${COLOR_BORDER_GRAY};
    padding: 0;
    color: ${COLOR_BORDER_GRAY};
    &-prev {
      left: 0;
    }
    &-next {
      right: 0;
    }
    img {
      pointer-events: none;
      width: 40%;
    }
  }
  .gallery__button-prev {
    width: 57px;
    left: 0;
    border: 0;
    background-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    &:focus {
      outline: 0;
    }
    height: 50px;
    top: -290px;
    @media ${screen.small} {
      top: -267px;
    }
    @media ${screen.medium} {
      top: -340px;
    }
    @media ${screen.largeXL} {
      height: 378px;
      top: -377px;
    }
  }
  .gallery__button-next {
    width: 57px;
    right: 0;
    border: 0;
    background-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    &:focus {
      outline: 0;
    }
    height: 50px;
    top: -290px;
    @media ${screen.small} {
      top: -267px;
    }
    @media ${screen.medium} {
      top: -340px;
    }
    @media ${screen.largeXL} {
      height: 378px;
      top: -377px;
    }
  }
  .ThumbnailsWrapperMobile {
    width: unset;
  }

  .slider {
    position: relative;
    .slider__item {
      width: 250px;
      height: 380px;
      color: black;
      display: flex;
      flex-direction: row;
      justify-content: center;

      div {
        position: relative;
      }
    }
    .slick-arrow {
      display: none !important;
    }
  }

  @media ${screen.largeXL} {
    display: none;
  }

  .video-container {
    background: #ebebeb;
    iframe {
      width: 100%;
      height: 420px;
    }
  }
`;

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  swipe: false,
};

class Gallery extends React.Component {
  state = {
    imageIndex: 0,
    vidThumbs: {},
  };

  changeImageIndex = (type) => {
    if (!['PREVIOUS', 'NEXT'].includes(type)) throw new Error('Invalid type.');

    let newIndex = this.state.imageIndex;
    if (type === 'PREVIOUS' && this.state.imageIndex > 0) {
      newIndex -= 1;
    }
    if (
      type === 'NEXT' &&
      this.state.imageIndex < this.props.images.length - 1
    ) {
      newIndex += 1;
    }
    this.slider.slickGoTo(newIndex);
    return this.setState({
      imageIndex: newIndex,
    });
  };

  handleThumbnailClick = (event) => {
    if (event.target.dataset.index) {
      this.setState({
        imageIndex: parseInt(event.target.dataset.index),
      });
    } else {
      console.error('[Alert] Invalid Event Target Clicked');
    }
  };

  renderThumbnails = (mobile = false) => {
    const { imageIndex } = this.state;
    const { images } = this.props;
    const totalImagesNum = images.length;
    let imagesRenderList = [];
    if (imageIndex >= totalImagesNum - 3) {
      // At end, render the last five
      for (let i = totalImagesNum - 5; i < totalImagesNum; i++) {
        if (images[i].image == null) {
          imagesRenderList.push(
            <div
              className={'thumbnail ' + (imageIndex === i ? 'active' : 'null')}
              key={images[i].video}
              onClick={this.handleThumbnailClick}
              data-index={i}
            >
              <iframe
                title="Product Video"
                style={{ pointerEvents: 'none' }}
                src={images[i].video}
                width="100"
                height="100"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          );
        } else {
          imagesRenderList.push(
            <div
              className={'thumbnail ' + (imageIndex === i ? 'active' : 'null')}
              key={
                images[i].image.localFile.childImageSharp.gatsbyImageData.images
                  .fallback.src
              }
              onClick={this.handleThumbnailClick}
              data-index={i}
            >
              <GatsbyImage
                image={
                  images[i].image.localFile.childImageSharp.gatsbyImageData
                }
                alt="c"
              />
            </div>
          );
        }
      }
    } else if (imageIndex < totalImagesNum - 3 && imageIndex >= 3) {
      // In the middle
      for (let i = imageIndex - 2; i <= imageIndex + 2; i++) {
        if (images[i].image == null) {
          imagesRenderList.push(
            <div
              className={'thumbnail ' + (imageIndex === i ? 'active' : 'null')}
              key={images[i].video}
              onClick={this.handleThumbnailClick}
              data-index={i}
            >
              <iframe
                title="Product Video"
                style={{ pointerEvents: 'none' }}
                src={images[i].video}
                width="100"
                height="100"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          );
          continue;
        }
        imagesRenderList.push(
          <div
            className={'thumbnail ' + (imageIndex === i ? 'active' : 'null')}
            key={
              images[i].image.localFile.childImageSharp.gatsbyImageData.images
                .fallback.src
            }
            onClick={this.handleThumbnailClick}
            data-index={i}
          >
            <GatsbyImage
              image={images[i].image.localFile.childImageSharp.gatsbyImageData}
              alt="c"
            />
          </div>
        );
      }
    } else {
      // Default, at beginning, render first five
      for (let i = 0; i < 5; i++) {
        const imageSrc = images[i].image
          ? images[i].image.localFile.childImageSharp.gatsbyImageData &&
            images[i].image.localFile.childImageSharp.gatsbyImageData.images
              .fallback.src
          : i;
        const hashedKey =
          imageSrc && imageSrc.length ? imageSrc.substring(8, 18) : `video${i}`;
        if (images[i].image === null) {
          imagesRenderList.push(
            <div
              className={'thumbnail ' + (imageIndex === i ? 'active' : 'null')}
              key={images[i].video}
              onClick={this.handleThumbnailClick}
              data-index={i}
            >
              <iframe
                title="Product Video"
                style={{ pointerEvents: 'none' }}
                src={images[i].video}
                width="100"
                height="100"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          );
          continue;
        }
        imagesRenderList.push(
          <div
            className={'thumbnail ' + (imageIndex === i ? 'active' : '')}
            key={hashedKey}
            onClick={this.handleThumbnailClick}
            data-index={i}
          >
            <GatsbyImage
              image={images[i].image.localFile.childImageSharp.gatsbyImageData}
              alt="c"
            />
          </div>
        );
      }
    }

    return imagesRenderList;
  };

  render() {
    const { images } = this.props;
    const { imageIndex } = this.state;
    return (
      <Fragment>
        <MobileGalleryWrapper>
          <Slider
            onSwipe={(dir) =>
              this.changeImageIndex(dir === 'left' ? 'NEXT' : 'PREVIOUS')
            }
            {...settings}
            className="slider"
            ref={(slider) => (this.slider = slider)}
          >
            {images.map((image, index) => {
              if (image.image == null) {
                return (
                  <div
                    className="slider__item"
                    key={image.video}
                    onClick={this.handleThumbnailClick}
                    style={{ overflow: 'hidden' }}
                  >
                    <div className="video-container">
                      <iframe
                        title="Product Video"
                        src={`${image.video}?autoplay=1`}
                        height="360"
                        frameBorder="0"
                        allowFullScreen
                      />
                    </div>
                  </div>
                );
              }
              return (
                <div key={image.title + index} className="slider__item">
                  <div>
                    <GatsbyImage
                      image={
                        images[index].image.localFile.childImageSharp
                          .gatsbyImageData
                      }
                      alt="c"
                    />

                    <GalleryCaption>
                      <p className="heading">Product Shown</p>
                      <div className="product-code">
                        <p>{images[index].productCode}</p>
                      </div>
                    </GalleryCaption>
                  </div>
                </div>
              );
            })}
          </Slider>

          <ThumbnailsWrapperMobile>
            {this.state.imageIndex !== 0 && (
              <button
                className="gallery__button gallery__button-prev"
                onClick={() => this.changeImageIndex('PREVIOUS')}
              >
                <img
                  alt="Previous"
                  src={staticImages.PAGINATION_ARROWS.PREVIOUS.default}
                />
              </button>
            )}

            {this.state.imageIndex !== this.props.images.length - 1 && (
              <button
                className="gallery__button gallery__button-next"
                onClick={() => this.changeImageIndex('NEXT')}
              >
                <img
                  alt="Next"
                  src={staticImages.PAGINATION_ARROWS.NEXT.default}
                />
              </button>
            )}
          </ThumbnailsWrapperMobile>
        </MobileGalleryWrapper>

        <DesktopGalleryWrapper>
          {this.state.imageIndex !== 0 && (
            <img
              className="prev-btn"
              alt="Previous"
              onClick={() => this.changeImageIndex('PREVIOUS')}
              src={staticImages.PAGINATION_ARROWS.PREVIOUS.default}
            />
          )}
          <BigImage>
            {images[imageIndex].image == null ? (
              <div className="video-container">
                <iframe
                  title="Product Video"
                  src={`${images[imageIndex].video}?autoplay=1`}
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            ) : (
              <Fragment>
                <GatsbyImage
                  image={
                    images[imageIndex].image.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  alt="c"
                />

                <GalleryCaption>
                  <p className="heading">Product Shown</p>
                  <div className="product-code">
                    <p>{images[imageIndex].productCode}</p>
                  </div>
                </GalleryCaption>
              </Fragment>
            )}
          </BigImage>

          {this.state.imageIndex !== this.props.images.length - 1 && (
            <img
              className="next-btn"
              alt="Next"
              onClick={() => this.changeImageIndex('NEXT')}
              src={staticImages.PAGINATION_ARROWS.NEXT.default}
            />
          )}
          <ThumbnailsWrapper>
            <button
              className="gallery__button gallery__button-prev"
              onClick={() => this.changeImageIndex('PREVIOUS')}
            >
              <img
                alt="Previous"
                src={staticImages.PAGINATION_ARROWS.PREVIOUS.default}
              />
            </button>
            <div className="gallery__thumbnails">{this.renderThumbnails()}</div>
            <button
              className="gallery__button gallery__button-next"
              onClick={() => this.changeImageIndex('NEXT')}
            >
              <img
                alt="Next"
                src={staticImages.PAGINATION_ARROWS.NEXT.default}
              />
            </button>
          </ThumbnailsWrapper>
        </DesktopGalleryWrapper>
      </Fragment>
    );
  }
}

export default Gallery;
